import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import "./css/DeductibleSchedule.css";
import useDeductibleSchedule from "./hooks/useDeductibleSchedule";

const DeductibleSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
  onNavigate,
}) => {
  const deductibleScheduleData = useDeductibleSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={deductibleScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {deductibleScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {deductibleScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={deductibleScheduleData.formFields}
        dropdownValues={deductibleScheduleData.dropdownValues}
        paramsData={deductibleScheduleData.paramsData}
        updataParamData={deductibleScheduleData.updateParamData}
        disabledDropdowns={deductibleScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={deductibleScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={deductibleScheduleData.selectMode}
        data={deductibleScheduleData.data}
        parmKey={deductibleScheduleData.parmKey}
        statusKey={deductibleScheduleData.statusKey}
        menuOptions={deductibleScheduleData.menuOptions}
        tableHeaders={deductibleScheduleData.columnDef}
        setRowData={deductibleScheduleData.setRowData}
        selectedPriceSchedules={deductibleScheduleData.selectedRows}
        setSelectedPriceSchedules={deductibleScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={deductibleScheduleData.first}
          rows={deductibleScheduleData.rows}
          totalRecords={deductibleScheduleData.totalRecords}
          currentPage={deductibleScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={deductibleScheduleData.onPageChange}
        />
      </div>
      {deductibleScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={deductibleScheduleData.isConfirmationModalOpen}
          onRequestClose={deductibleScheduleData.closeConfirmationModal}
          onBack={deductibleScheduleData.closeConfirmationModal}
          onSave={deductibleScheduleData.deleteDeductibleSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={deductibleScheduleData.setSelectedOption}
        />
      )}
      {deductibleScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={deductibleScheduleData.isHideConfirmationModalOpen}
          onRequestClose={deductibleScheduleData.closeHideConfirmationModal}
          onBack={deductibleScheduleData.closeHideConfirmationModal}
          onSave={deductibleScheduleData.hideUnhideDeductibleSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={deductibleScheduleData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default DeductibleSchedule;
